export const createMfaSlice = (set) => ({
    mfaEnrolled: null,
    setMfaEnrolled: (enrolled) => set({ mfaEnrolled: enrolled }),
    mfaSessionVerified: false,
    setMfaSessionVerified: (verified) => set({ mfaSessionVerified: verified }),
});
//# sourceMappingURL=mfaSlice.js.map